import * as React from 'react';
import { cloneDeep, flow, last, } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { reduxForm } from 'redux-form';
import { IMtaFormNames, PageForm } from '../../../../../../../../services/mta/models';
import { Button, Form } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { MTAButtons } from '../../../MTAButtons';
import { MTACardHeader } from '../Components/MTACardHeader';
import { MTADeclarationContent } from './Components/MTADeclarationContent';

class MTADeclarationForm extends React.Component<any, any> {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public handleSubmit = () => {
    const { actions, redirectUrl } = this.props;
    actions.mta.handleMTASubmit(redirectUrl);
  }

  public render() {
    const { submitting, handleSubmit, valid, submitFailed, mta } = this.props;
    const policyId = mta.selectedPolicy.id || null;
    const policyNumber = mta.selectedPolicy.policyNumber || null;
    const isAnnual = mta.selectedPolicy?.metadata?.scheme_type === 'annual';
    const region = mta.selectedPolicy?.metadata?.region || null;
    const buttonBack = policyId ? (
      <Link to={`/account/make-a-change/selection/${policyId}`}>
        <Button
          id="back"
          bsStyle="primary"
          className="left secondary-button medium-width"
          disabled={submitting}
        >GO BACK</Button>
      </Link>
    ) : null;
    const buttonSubmit = (
      <Button
        id="continue"
        bsStyle="primary"
        type="submit"
        className="pull-right secondary-button medium-width"
        disabled={submitting || (submitFailed && !valid)}
      >
        CONTINUE
      </Button>
    );

    const allRegions = {
      uk: 'United Kingdom',
      europe: 'Europe',
      worldwide_excluding: 'Worldwide Excluding',
      worldwide: 'Worldwide',
    }

    let headerText = `Make a Change to your Single trip Policy Ref: ${policyNumber}`;

    if (isAnnual && region) {
      headerText = `Make a Change to your Annual Multi Trip ${allRegions[region]} Policy Ref: ${policyNumber}`
    }

    return (
      <>
        {submitFailed && !valid && (
          <div className="error-block-container">
            <h1>Whoops!</h1>
            <p>Missing something? Please check the areas marked in orange before you continue.</p>
          </div>
        )}
        <div className={'mt-30'}/>
        <MTACardHeader text={headerText}/>
        <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
          <MTADeclarationContent/>
          <div className={'mt-15'}/>
          <MTAButtons button1={buttonBack} button2={buttonSubmit}/>

        </Form>
      </>
    );
  }
}

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    return component;
  },
  connect(
    (state: IStore) => {
      const mtaPolicy = cloneDeep(state.mta.selectedPolicy);
      const latestPremium = last(mtaPolicy.premiums);
      mtaPolicy.effective_date = new Date();
      mtaPolicy.mta = true;
      mtaPolicy.scheme_id = latestPremium ? latestPremium.scheme.id : null;

      return {
        mta: state.mta,
        auth: state.auth,
        initialValues: {
          coverDetailsDeclaration: false,
          page: PageForm.MTA_DECLARATION,
          isUpsell: false,
          changingMedical: false,
          addingTravellers: false,
          removeOption: [],
          premium: null,
          selectedTravellers: {
            waitingList: [],
            isTerminal: [],
          }
        },
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
])(MTADeclarationForm);
